import { H5BookTypeDetail } from '@/config/baseConfig';
const { WEB_BASE_URL } = window.__appBaseConfig__;

export function getShareUrl(type, id) {
  const url = `${H5BookTypeDetail[type]}?id=${id}&fromShare=true`;
  // 判断当前链接是否是在 textbook.cucp.com.cn 下
  const isTextbookDomain = window.location.hostname === 'textbook.cucp.com.cn';
  const baseUrl = `${WEB_BASE_URL}${isTextbookDomain ? 'h5' : 'zhongchuanh5'}/#/`;
  const openUrl = `${baseUrl}${url}`;
  // console.error('openUrl', openUrl)
  // 你可以根据 isTextbookDomain 做不同处理，这里暂时只是返回 openUrl
  return `${openUrl}`;
  // return `${baseUrl}/home?reopen=${baseUrl}${url}`;
}
